import axios from "axios";
import Cookies from "js-cookie";
import "@/plugins/bridge.js";
import { triggerLogin } from "../utils/triggerLogin";

// import { auth } from '@/utils';
import { Toast } from "@vant/compat";
// import router from '@/router';

axios.defaults.timeout = 1000 * 60;
axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded;charset=UTF-8";

// 创建axios实例
const service = axios.create({
  // baseURL: "https://zsrbapp.zsnews.cn",
  // 根据不同env设置不同的baseURL
  baseURL: process.env.VUE_APP_BASE_URL
});

const getSessionToken = () => {
  const session_token = sessionStorage.getItem("session_token");
  return !session_token ||
    session_token === "null" ||
    session_token === "undefined"
    ? ""
    : session_token;
};

const getToken = () => {
  const token = Cookies.get("token");
  return !token || token === "null" || token === "undefined" ? "" : token;
};

console.log("service====>", getSessionToken(), getToken());

// axios实例拦截请求
service.interceptors.request.use(
  (config) => {
    config.headers = {
      ...config.headers,
      sessionToken: getSessionToken(),
      token: getToken()
    };
    Toast.loading({
      forbidClick: true,
      message: "加载中..."
    });
    return config;
  },
  (error) => {
    Toast.clear();
    return Promise.reject(error);
  }
);

// axios实例拦截响应
service.interceptors.response.use(
  // 2xx时触发
  (response) => {
    Toast.clear();
    console.log(response);
    // response.data就是后端返回的数据，结构根据你们的约定来定义
    const { code, message } = response.data;
    let errMessage = "";
    switch (code) {
      case 1:
        break;
      case 0:
        errMessage = message;
        // router.go(-1);
        break;
      case 401:
        console.log("code401");
        reloadLogin();
        break;

      default:
        errMessage = message;
        break;
    }
    if (errMessage) Toast.fail(errMessage);
    return response;
  },
  // 非2xx时触发
  (error) => {
    console.log("error===", error, error.response?.data?.message);
    const status = error.response ? error.response.status : null;
    console.log(status);
    // debugger;
    if (status === 401) {
      // 调用登录接口
      console.log("9999999登录失败");
      reloadLogin();
      // 清楚用户信息
    } else {
      Toast.fail("网络错误，请稍后重试");
      return Promise.reject(error);
    }
  }
);

const reloadLogin = () => {
  try {
    const userAgentString = navigator.userAgent.toLowerCase();

    // 微信环境
    if (userAgentString.indexOf("micromessenger") >= 0) {
      triggerLogin();
    }
    // App 环境
    else if (userAgentString.indexOf("zsrbapp") >= 0) {
      window.ZsrbApp.call("clearUserInfo", {}, () => {
        console.log("进入clearUserInfo桥接，重新登录");
        triggerLogin();
      });
    } else {
      Toast.fail("请在中山+App或微信环境中操作！");
    }
  } catch {
    triggerLogin();
  }
};

export default service;
